export const DISALLOWED_FILE_TYPES = [
  'html',
  'exe',
  'bat',
  'sh',
  'py',
  'js',
  'jar',
  'dll',
  'php',
  'pl',
  'rb',
  'cgi',
  'ps1',
  'wsf',
  'vbs',
  'cmd',
  'iso',
  'zip',
];

export const MAX_FILE_SIZE_BYTES = 100 * 1024 * 1024; // 100 MB
export const MAX_FILES_UPLOAD = 10;
export const ROOT_FOLDER_PAGE_LIMIT = 6;
export const ASSETS_PER_TYPE_PAGE_LIMIT = 5;
export const ASSETS_MAX_SEARCH_RESULTS = 10;
export const ASSET_MODAL_LG_WIDTH = 800;
